import { axiosAction } from "../../utils/axiosAction";
import { 
    ATTRIBUTES_CATEGORIES_FETCH,
    LANGUAGES_FETCH,
    ATTRIBUTES_MODEL_FETCH,
    ATTRIBUTES_ARCHIVE,
 } from "../action-types/attributes-types";

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_ATTRIBUTES}`;
const ENDPOINT_LANGUAGES = `${process.env.REACT_APP_ENDPOINT_LANGUAGES}`;
const ENDPOINT_ATTRIBUTES_CATEGORIES = `${process.env.REACT_APP_ENDPOINT_ATTRIBUTES_CATEGORIES}`;

export const archiveAttribute = (id: string) => async dispatch => {
    return axiosAction.patch(
        `${ENDPOINT}/${id}/archive`,
        ATTRIBUTES_ARCHIVE,
        dispatch,
    );
};

export const unArchiveAttribute = (id: string) => async dispatch => {
    return axiosAction.patch(
        `${ENDPOINT}/${id}/unarchive`,
        ATTRIBUTES_ARCHIVE,
        dispatch,
    );
};

export const getAttributesCategories = async dispatch => {
    return axiosAction.get(
        ENDPOINT_ATTRIBUTES_CATEGORIES,
        ATTRIBUTES_CATEGORIES_FETCH,
        dispatch,
    );
};

export const getLanguages = async dispatch => {    
    return axiosAction.get(
        ENDPOINT_LANGUAGES,
        LANGUAGES_FETCH,
        dispatch
    );
};

export const getAttributes = ({ page = 1, limit = 100000, brand = '' }: { page?: number, limit?: number, brand?: string }) => async dispatch => {
    return axiosAction.get(
        ENDPOINT,
        ATTRIBUTES_MODEL_FETCH,
        dispatch,
        {
            params: {
                page, 
                limit,
                brand
            }
        }
    )
}
